import { createFileRoute } from "@tanstack/react-router";

import AuthPageContainer from "@/features/auth/containers/auth-page-container";
import { beforeGuestGuard } from "@/features/auth/guards";

function SignInPage() {
  return <AuthPageContainer mode="signin" redirectTo="/app/clients" />;
}

// Inferred child route: /signin
export const Route = createFileRoute("/signin")({
  beforeLoad: beforeGuestGuard,
  ssr: false,
  component: SignInPage,
});
